import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    fechaImputacion: moment(new Date()).format('YYYY-MM-DD'),
    presupuestoInternoId: 0,
    presupuestoNumero: 0,
    // presupuestoAdicionalNumero: 0,
    cliente: '',
    accion: '',
    ordenTrabajoId: 0,
    ordenTrabajo: '',
    importe: 0,
    observaciones: '',

    importeTransferencias: 0,
    importeImputaciones: 0,
    saldoImputar: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR' (state) {
        state.fechaImputacion = moment(new Date()).format('YYYY-MM-DD');
        state.presupuestoInternoId= 0;
        state.presupuestoNumero= 0;
        state.presupuestoAdicionalNumero= 0;
        state.cliente = '';
        state.accion = '';
        state.ordenTrabajoId = 0;
        state.ordenTrabajo = '';
        state.importe = 0;
        state.observaciones = '';

        state.importeTransferencias = 0;
        state.importeImputaciones = 0;
        state.saldoImputar = 0;
    },
    'SET_SALDOS' (state, saldos) {
        state.importeTransferencias = parseFloat(saldos.importeTransferencias);
        state.importeImputaciones = parseFloat(saldos.importeImputaciones);
        state.saldoImputar = parseFloat(saldos.importeTransferencias) - parseFloat(saldos.importeImputaciones);
    },
    // 'INICIALIZAR_PRESUPUESTO_INTERNO' (state) {
    //     state.presupuestoInternoId = 0;
    //     state.presupuestoNumero = 0;
    //     state.presupuestoAdicionalNumero = 0;
    //     state.cliente = '';
    //     state.accion = '';
    //     state.ordenTrabajoId = 0;
    //     state.ordenTrabajo = '';
    // },
    'SET_PRESUPUESTO_INTERNO' (state, params) {
        state.presupuestoInternoId = params.presupuestoInterno? params.presupuestoInterno.id : 0;
        state.presupuestoNumero = params.presupuestoInterno? params.presupuestoInterno.presupuestoNumero : '';
        state.cliente = params.presupuestoInterno? params.presupuestoInterno.cliente.trim() : '';
        state.accion = params.presupuestoInterno? params.presupuestoInterno.accion.trim() : '';
        state.ordenTrabajoId = params.ordenTrabajo? params.ordenTrabajo.id : 0;
        state.ordenTrabajo = params.ordenTrabajo? `${params.ordenTrabajo.id.toString()} - ${params.ordenTrabajo.titulo}` : '';
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR');

            apiAxios.get('bancosmovimientos/transferencias-premios-imputaciones-saldos')
                .then(res => {
                    commit('SET_SALDOS', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';

            if (parseFloat(state.importe) == 0) {
                save = false;
                errorMessage = "Debe ingresar el importe de la imputación."
            }

            if (save) {
                let imputacion= {
                    fechaImputacion: moment(state.fechaImputacion).format('YYYY-MM-DD'),
                    presupuestoInternoId: parseInt(state.presupuestoInternoId),
                    ordenTrabajoId: parseInt(state.ordenTrabajoId),
                    importe: parseFloat(state.importe),
                    observaciones: state.observaciones.trim(),
                };
                
                apiAxios.post('bancosmovimientos/transferencias-premios-imputaciones', imputacion)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
    // inicializarPresupuestoInterno: ( { commit } ) => {
    //     return new Promise((resolve, reject) => {
    //         commit('INICIALIZAR_PRESUPUESTO_INTERNO');
    //         resolve();
    //     })
    // },
    setPresupuestoInterno: ( { commit }, params ) => {
        return new Promise((resolve, reject) => {
            commit('SET_PRESUPUESTO_INTERNO', params);
            resolve();
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}